'use strict';

var centralApp = angular.module('app.components');

centralApp.component('versao', {
    controllerAs: '$ctrl',
    controller: versaoSistemaCtrl,
    template: '<i class="fa fa-anchor" aria-hidden="true"></i> <i ng-bind="$ctrl.versao"></i>'
});

versaoSistemaCtrl.$inject = ['sistemaApi'];
function versaoSistemaCtrl(sistemaApi) {
    var $ctrl = this;

    sistemaApi.versao().then(function (response) {
        console.log(response);
        $ctrl.versao = response;
    });
}


//////////////////
// WEBPACK FOOTER
// ../Projecao.ContactCenter.WebApp.Compartilhado/components/versao/index.js
// module id = 321
// module chunks = 1